<template>
  <div class="input-label flex flex-col">
    <label for="input" class="text-base w-1/2">{{ $ctx.locale == 'en' ? setting.enName: setting.arName }}</label>
    <div class="flex gap-2">
      <div class="w-full md:w-1/2 lg:w-1/3">
        <el-input @keyup.enter="update" @input="onChange" class="w-full" type="number" v-model="val" />
      </div>
      <el-button v-if="changed" @click="update">{{ t('update') }}</el-button>
    </div>
  </div>
</template>
<script setup lang="ts">
import {useI18n} from "vue-i18n";
import {onMounted, ref} from "vue";
import {useSettingsStore} from "@/stores/settingsStore";

const props = defineProps(['setting'])

const messages = {
  en: {},
  ar: {},
}
const {t} = useI18n({messages, useScope: 'global'})
const settingsStore = useSettingsStore();

const val = ref()
const changed = ref(false)

onMounted(() => {
  val.value = props.setting.value;
})


function onChange() {
  changed.value = true;
}

async function update() {
  try {
    await settingsStore.updateSetting(props.setting.key, props.setting.id, val.value)
    changed.value = false;
  } catch (e) {
    console.log(e)
  }
}
</script>
